export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    CREATE_CONTACT: 'CREATE_CONTACT',
    CREATE_ACCOUNT: 'CREATE_ACCOUNT',
    FORCE_UPDATE: 'FORCE_UPDATE',
    QUICK_TRANSFER: 'QUICK_TRANSFER',
    ACCOUNT_STATEMENT: 'ACCOUNT_STATEMENT',
    ROLE_DETAILS: 'ROLE_DETAILS',
    DASHBOARD: 'DASHBOARD',
    HEADER: 'HEADER',
    RESET_HEADER: 'RESET_HEADER',
    API_DETAILS: 'API_DETAILS',
    CHANGE_PASSWORD:'CHANGE_PASSWORD',
    MERCHANT_PROFILE:'MERCHANT_PROFILE',
    USERS:'USERS',
    ADDUSERS:'ADDUSERS',
    EDITUSERS:'EDITUSERS',
    USERROLE:'USERROLE',
    ROUTELIST:'ROUTELIST',
    LOADER:'LOADER',
    PREFIX:'PREFIX',
    BULKUPLOAD:'BULKUPLOAD',
    ACL_ROUTES:'ACL_ROUTES',
    ACL_LOAD:'ACL_LOAD',
    PAYOUTLINK:'PAYOUTLINK',
    INVOICE:'INVOICE',
    SCHEDULEPAYMENT:'SCHEDULEPAYMENT',
    PAYOUT_REQUEST:'PAYOUTREQUEST'
};